<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'AllDicts' }" id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к справочникам
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<div class="name">
							<h3 class="title">Список доступных справочников для калькулятора:</h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn">
								<div class="md-layout">
									<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn text-right">
										<router-link :to="{ name: 'calcdictGroupData', params: {dictCode: 'new', code: 'new', id: 'new' }}"
													 class="md-primary"
													 tag="md-button">
											Добавить новый элемент
										</router-link>
									</div>
								</div>
								<md-card v-if="calcdictListData.length>0" class="md-card-plain">
									<md-card-content>
										<md-table class="table-shopping" v-model="calcdictListData">
											<md-table-row slot="md-table-row" slot-scope="{ item }">
												<md-table-cell md-label="Код справочника">
													<router-link
															:to="{ name: 'calcdictGroupData', params: { dictCode: item.dictCode, code: item.dictCode, id:item.id } }">
														{{ item.dictCode }}
													</router-link>
												</md-table-cell>
												<md-table-cell md-label="Название">
													<router-link
															:to="{ name: 'calcdictGroupData', params: { dictCode: item.dictCode, code: item.dictCode, id:item.id } }">
														{{ item.dictName }}
													</router-link>
												</md-table-cell>

												<md-table-cell>
													<router-link
															:to="{ dictCode: item.dictCode, name: 'calcdictGroupData', params: { code: item.dictCode, dictCode: item.dictCode, action: 'delete', id:item.id } }"
															event="" @click.native.prevent="confirmDelete({ dictCode: item.dictCode, name: 'calcdictGroupData', params: { code: item.dictCode, dictCode: item.dictCode, action: 'delete', id:item.id } })"
													>
														<md-icon>delete</md-icon>
													</router-link>
												</md-table-cell>
											</md-table-row>
										</md-table>
									</md-card-content>
								</md-card>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { reAuthenticate } from '@/utils/auth-api'
    import { getCalcdictionaryListData } from '@/utils/dict-api'

    export default {
        props: ['calcdictId', 'page'],
        bodyClass: 'model-list',
        data () {
            return {
                options: [],
                dictId: this.$route.params.dictCode,
                calcdictListData: [],
                pagination: {
                    currentPage: 1,
                    total: 1,
                    fromRec: 0,
                    toRec: 0,
                    totalRec: 0,
                },
                filterData: {
                    page: this.page || 1,
                },
            }
        },
        watch: {
            dictionaryId: {},
        },
        computed: {},
        methods: {
            getCalcdict () {
                getCalcdictionaryListData().then(result => {
                    this.calcdictListData = result
                }).catch(error => {
                    reAuthenticate(this.$router, this.$route, error)
                })
            },
			confirmDelete (route) {
				if (confirm("Действительно удалить?")) {
					this.$router.push(route);
				}
			}
        },
        created () {
            this.getCalcdict()
        },
        mounted () {
        },
    }
</script>
<style lang="scss" scoped type="text/scss">
	.savebtn {
		margin-right: 0;
		padding-right: 5px;
	}

</style>
